import { getOffset } from '../../Utils/utils'
export const scrollNavbar = () => {
  const headerHeight = document.querySelector('header .header_fix').offsetHeight
  const windowHeight = window.innerHeight
  const contentSections = document.querySelectorAll('section.section_content')
  const sectionsLinks = document.querySelectorAll('.scroll_page_nav li a')

  if (contentSections?.length) {
    document.addEventListener('scroll', () => {
      contentSections.forEach((section, index) => {
        const sectionTitle = section ? section.querySelectorAll('.title_section') : null
        if (sectionTitle?.length) {
          sectionTitle.forEach((title) => {
            if (title?.closest('only_mobile_tablet')) {
              return
            }

            const scrollNavItem = document.querySelector(`.item-num-${index}`)

            const sectionObject = {
              el: section,
              top: getOffset(title).top,
              height: section?.offsetHeight,
              el_scrolled: false
            }

            if (sectionObject.top - windowHeight / 2 < window.pageYOffset) {
              scrollNavItem?.classList.add('is_active')
            } else {
              scrollNavItem?.classList.remove('is_active')
            }
          })
        }
      })
    })
  }

  if (sectionsLinks?.length) {
    sectionsLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        const sectionNumber = link.dataset.section
        window.scrollTo({
          top: getOffset(contentSections[sectionNumber]).top - headerHeight - 100,
          behavior: 'smooth'
        })
      })
    })
  }
}
